const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {},
  button: {
    ...theme.typography.button,
    textTransform: 'none'
  },
  limitNVP: {
    ...theme.typography.button,
    textTransform: 'none',
    marginTop: '4.5em'
  },
  NVP: {
    ...theme.typography.button,
    textTransform: 'none',
    marginTop: '2.5em'
  },
  title: {
    fontSize: '3em'
  },
  cardContent: {
    padding: '0px !important'
  },
  cardActions: {
    padding: '4px 4px',
    height: 'auto'
  },
  cardActionsTitle: {
    background: '#005795 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtestpassed: {
    background: '#43A547!important',
    padding: '5px',
    textAlign: 'center'
  },
  subtestfailed: {
    background: '#ff5252!important',
    padding: '5px',
    textAlign: 'center'
  },
  subtesttitle: {
    color: '#FFFFFF'
  },
  cardActionsNav: {
    background: '#FF643B !important',
    padding: '5px',
    textAlign: 'center'
  },
  nav: {
    padding: 'initial',
    minWidth: 'initial',
    minHeight: 'initial'
  },
  borderpassed: {
    border: '2px solid #43A547'
  },
  borderfailed: {
    border: '2px solid #ff5252'
  },
  tablerow: {
    height: '15px'
  },
  tableheader: {
    padding: '8px 5px 9px 5px'
  },
  title: {
    fontSize: '2em'
  },
  subtestHeight: {
    height: 235
  },
 // tableContainer: {
  //  height: '100%',
  //  overflowY: 'auto'
 // },
  impedancePair: {
    display: 'block'
  },
  impedancePairTitle: {
    display: 'inline',
    marginRight: '10px',
    fontWeight: 'bold'
  },
  impedancePairValue: {
    display: 'inline',
  },
  hyphen:{
    fontSize: '1.5em',
    textAlign:'right'
  }
})

export default styles
